import PolicyDocumentPage from '../../components/policies/PolicyDocumentPage';

function AcceptancePolicyPage() {
  return (
    <PolicyDocumentPage
      type="acceptance"
      title="User Acceptance Policy"
      eyebrow="Customer policy"
      emptyMessage="No Acceptance Policy has been published yet."
    />
  );
}

export default AcceptancePolicyPage;
